import axios from 'axios';
import { BASE_URL, TIMEOUT, statusCode } from './config';

import { getAppBaseInfo, isInDocoiApp } from '../utils/app';
import { showToast } from 'vant';
import { getStorage, setStorage } from '../utils/storage';
import type { AxiosInstance, InternalAxiosRequestConfig } from './type';
import { errorMonitor } from '../utils/errorMonitor';
import JSBridge from '../bridge';
import { useLogin } from '../composables/useLogin';
import { isTestEnv } from '../utils/env';

const instance: AxiosInstance = axios.create({
  baseURL: BASE_URL,
  timeout: TIMEOUT
});

let testEnv = isTestEnv();
let appBaseInfo = getAppBaseInfo();
// 添加请求拦截器
instance.interceptors.request.use(
  async (config: InternalAxiosRequestConfig) => {
    let docoiTokenStr = getStorage('docoiToken');
    let docoiToken = docoiTokenStr ? JSON.parse(docoiTokenStr) : {};
    let token = docoiToken?.token || '';
    let tempToken = docoiToken?.tempToken || '';
    if (appBaseInfo && !config.no_token && !token) {
      await JSBridge.callAsync('getToken')
        .then((data: any) => {
          let objData: any = {};
          objData = data;
          token = objData.token || '';
          tempToken = objData.visitor_token || '';
          setStorage('docoiToken', JSON.stringify({ token, tempToken }));
        })
        .catch((error) => {
          console.log(error);
        });
    }
    if (!config.no_token) {
      config.headers['token'] = config?.customToken || token || tempToken || ''; //获取token
    }
    config.headers['app_version'] = appBaseInfo?.app_version;
    config.headers['device_id'] = appBaseInfo?.device_id;
    config.headers['os'] = appBaseInfo?.os;
    config.headers['os_version'] = appBaseInfo?.os_version;
    config.headers['ways'] = '2'; // 1: 服务器管家 , 2: H5
    config.headers['channel'] = appBaseInfo?.channel;
    return config;
  },
  (error) => {
    console.log('request: error', error);
    return Promise.reject(error);
  }
);

// 添加响应拦截器
instance.interceptors.response.use(
  (response) => {
    let { code, message: msg } = response.data;
    const requestConfig = (response.config || {}) as InternalAxiosRequestConfig;
    const isShowToast = !requestConfig.no_toast;
    const isShowLogin = !requestConfig.no_login;
    //401token失效 420动态不存在 429业务错误，根据reason判断具体类型
    if (code !== 200 && code !== 401 && code !== 420 && code !== 429) {
      isShowToast && showToast({ duration: 3000, message: msg, teleport: document.getElementById('app') });
    } else if (code === 401) {
      setStorage('docoiToken', '');
      if (isInDocoiApp()) {
        JSBridge.call('login');
      } else if (testEnv && isShowLogin) {
        const { showLogin } = useLogin({
          onSuccess: () => {
            // window.location.reload();
          }
        });
        showLogin();
      }
      return Promise.reject(response.data);
    }
    return response;
  },
  (err) => {
    if (err.name === 'CanceledError' || err.name === 'AbortError') {
      return Promise.reject(err);
    }
    // 上报接口请求错误
    errorMonitor.reportRequestError(err, err.config);
    if (err.response) {
      // 服务器（或网关）返回了错误响应
      showToast({
        duration: 3000,
        message: statusCode[err.response.status] || '网络错误, 请检查网络链接情况！',
        teleport: document.getElementById('app')
      });
    } else {
      showToast({
        duration: 3000,
        message: err.code === 'ECONNABORTED' ? '请求超时，请稍后重试' : '网络异常，请检查网络连接',
        teleport: document.getElementById('app')
      });
    }

    //到catch中处理
    return Promise.reject(err);
  }
);

export default instance;
export { instance as http };
